import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import './preview.css';

const NewsPreview = (params) => {

    let title = params.title;
    let date = params.date;
    let place = params.place;
    let desc = params.description;
    let image = params.image;
    let type = params.type;

    return (
        <div className={"news-preview news-preview-" + type} >
            <div className="news-preview-image">
                <img src={image} alt={title}></img>
            </div>
            <div className="news-preview-description">
                <p className="news-preview-title">{title}</p>
                <span className="news-preview-place">{place}</span>,
                <span className="news-preview-date">{date}</span>

                <div className="news-preview-text">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{desc}</ReactMarkdown>
                </div>
            </div>
        </div>
    )
};


export default NewsPreview